import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServizioMenuService } from 'src/app/shared/services/servizio-menu.service';
import { Articolo, ArticoloFull } from 'src/app/shared/interfaces/custom/articolo';
import { CategoriaAttualeService } from 'src/app/shared/services/custom/categoria-attuale.service';
import { Link } from 'src/app/shared/interfaces/link';

@Component({
  selector: 'app-category-list-container',
  templateUrl: './category-list-container.component.html',
  styleUrls: ['./category-list-container.component.scss']
})
export class CategoryListContainerComponent implements OnInit {
  items: Articolo[] = [];
  breadcrumbs: Link[] = [];


  constructor(
    private route: ActivatedRoute,
    private menuService: ServizioMenuService,
    private categoriaService: CategoriaAttualeService
  ) {}

  ngOnInit(): void {
     this.menuService.getFamiglie();
     this.categoriaService.loadCategorie();

    this.route.paramMap.subscribe(params => {
      const codicefamiglia = params.get('codice');
      if (codicefamiglia) {
       
        console.log('Codice famiglia ricevuto:', codicefamiglia);
        this.menuService.getProduct(codicefamiglia).subscribe(response => {
          this.items = response;
        });
        
        const ids = codicefamiglia.split('-'); 
        this.categoriaService.getPartialBreadcrumbs(ids).subscribe(links => {
          this.breadcrumbs = links;
        });
      }
    });
  }
}
